import { render } from "./Login.vue?vue&type=template&id=64fb3242&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=64fb3242&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64fb3242"

export default script